import api from '@/services/gateway/api';
import router from '@/vue-instance/router';
import store from '@/vue-instance/store';

const baseUrl = 'camp/sales/employees';

const normalizeErrors = (errors) => {
  if (!errors) {
    return {};
  }
  if (Array.isArray(errors)) {
    return errors.reduce((acc, item) => {
      if (item && typeof item === 'object') {
        Object.keys(item).forEach((key) => {
          const value = item[key];
          acc[key] = Array.isArray(value) ? value : [value];
        });
      }
      return acc;
    }, {});
  }
  return Object.keys(errors).reduce((acc, key) => {
    const value = errors[key];
    acc[key] = Array.isArray(value) ? value : [value];
    return acc;
  }, {});
};

const state = {
  list: [],
  meta: {
    current_page: 1,
    per_page: 20,
    total: 0,
    last_page: 1
  },
  item: {},
  cities: [],
  positions: []
};

const getters = {
  getList: (state) => state.list,
  getMeta: (state) => state.meta,
  getItem: (state) => state.item,
  getCities: (state) => state.cities,
  getPositions: (state) => state.positions
};

const mutations = {
  setList (state, data) {
    state.list = data;
  },
  setMeta (state, data) {
    state.meta = data || state.meta;
  },
  setItem (state, data) {
    state.item = data;
  },
  setCities (state, data) {
    state.cities = data;
  },
  setPositions (state, data) {
    state.positions = data;
  }
};

const actions = {
  actionGetList ({ commit }, payload) {
    return api.get(baseUrl, { params: payload })
      .then((response) => {
        commit('setList', response.data.data);
        commit('setMeta', response.data.meta);
        return response.data;
      });
  },
  actionGetItem ({ commit }, id) {
    return api.get(`${baseUrl}/${id}`)
      .then((response) => {
        commit('setItem', response.data.data);
        return response.data.data;
      });
  },
  actionCreate ({ commit, dispatch }, payload) {
    return api.post(baseUrl, payload)
      .then((response) => {
        router.push({ name: 'camp.sales-employees.index' });
        return response.data;
      })
      .catch((error) => {
        if (error.response && error.response.status === 422) {
          store.dispatch('validation/setErrors', normalizeErrors(error.response.data.errors));
        }
        throw error;
      });
  },
  actionUpdate ({ commit }, { id, payload }) {
    return api.post(`${baseUrl}/${id}`, { ...payload, _method: 'PUT' })
      .then((response) => {
        router.push({ name: 'camp.sales-employees.index' });
        return response.data;
      })
      .catch((error) => {
        if (error.response && error.response.status === 422) {
          store.dispatch('validation/setErrors', normalizeErrors(error.response.data.errors));
        }
        throw error;
      });
  },
  actionRemove ({ commit }, id) {
    return api.delete(`${baseUrl}/${id}`);
  },
  actionGetCities ({ commit }) {
    return api.get('camp/sales/cities', { params: { is_active: true } })
      .then((response) => {
        commit('setCities', response.data.data);
        return response.data.data;
      });
  },
  actionGetPositions ({ commit }) {
    return api.get('camp/sales/positions', { params: { is_active: true } })
      .then((response) => {
        commit('setPositions', response.data.data);
        return response.data.data;
      });
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
